import type { Receipt } from '@white-label-types/parking-checkout';
import {
  parseTravelInsuranceQuoteDetails,
} from '@white-label-helper/data-parsers-travel-insurance';

export function parseReceiptState(baseState: Receipt) {
  return {
    ...baseState,
    items: baseState.items.map((item) => {
      const quoteDetails = parseTravelInsuranceQuoteDetails(item);
      return {
        ...item,
        parkingName: item.inventory_item.product_name,
        locationInfo: item.poi,
        orderId: item.order_reference,
        ...(quoteDetails ? { quoteDetails } : {}),
      };
    }),
  };
}
